import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Allroutes from "./routes/Allroutes/Allroutes";

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <Allroutes />
    </div>
  );
}

export default App;
